import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Bell, ShieldCheck } from "lucide-react";
import { API } from "../../../config";

export const SmsAdminTools = ({ summary, isSuper, onChanged }) => {
  const [threshold, setThreshold] = useState(String(summary.threshold_eur));
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");

  const saveThreshold = async () => {
    try {
      await axios.put(`${API}/admin/sms-credit/threshold`, { threshold_eur: Number(threshold.replace(",", ".")) });
      toast.success("Soglia di avviso salvata");
      onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore salvataggio soglia"); }
  };

  const adjust = async () => {
    try {
      await axios.post(`${API}/admin/sms-credit/adjust`, { amount_eur: Number(amount.replace(",", ".")), note });
      toast.success("Rettifica registrata");
      setAmount(""); setNote("");
      onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Errore rettifica"); }
  };

  return (
    <div className="bg-[#111] border border-gray-800 rounded-2xl p-6 space-y-6" data-testid="sms-admin-tools">
      <div>
        <p className="flex items-center gap-2 text-sm font-semibold text-white mb-2"><Bell size={16} /> Soglia avviso credito basso</p>
        <p className="text-xs text-gray-400 mb-3">Sotto questa soglia gli admin ricevono un'email (al massimo una ogni 24 ore).</p>
        <div className="flex gap-2">
          <input value={threshold} onChange={(e) => setThreshold(e.target.value)} className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white outline-none focus:border-gray-500 flex-1" inputMode="decimal" data-testid="sms-threshold-input" />
          <button onClick={saveThreshold} className="btn-lojack-outline text-sm" data-testid="sms-threshold-save">Salva</button>
        </div>
      </div>
      {isSuper && (
        <div className="border-t border-gray-800 pt-5" data-testid="sms-adjust-section">
          <p className="flex items-center gap-2 text-sm font-semibold text-white mb-2"><ShieldCheck size={16} /> Rettifica manuale (Super Admin)</p>
          <p className="text-xs text-gray-400 mb-3">Importo positivo per un accredito (es. omaggio), negativo per un addebito.</p>
          <input value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="Importo € (es. 20 o -5)" className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white outline-none focus:border-gray-500 w-full mb-2" inputMode="decimal" data-testid="sms-adjust-amount" />
          <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Causale" className="bg-[#0a0a0a] border border-gray-700 rounded-xl px-3 py-2 text-white outline-none focus:border-gray-500 w-full mb-2" data-testid="sms-adjust-note" />
          <button onClick={adjust} disabled={!amount || !note} className="btn-lojack w-full text-sm disabled:opacity-50" data-testid="sms-adjust-submit">Registra rettifica</button>
        </div>
      )}
    </div>
  );
};
